export interface LiteCapability {
  allowed: boolean;
  antialias: boolean;
  balancedAllowed?: boolean;
  reason?: "reduced-motion" | "save-data" | "webgl-unsupported";
}
export function decideLiteCapability(signals: {
  reducedMotion: boolean;
  dataSaver: boolean;
  webgl: boolean;
  devicePixelRatio: number;
  viewportWidth?: number;
}): LiteCapability {
  if (signals.reducedMotion)
    return {
      allowed: false,
      balancedAllowed: false,
      antialias: false,
      reason: "reduced-motion",
    };
  if (signals.dataSaver)
    return {
      allowed: false,
      balancedAllowed: false,
      antialias: false,
      reason: "save-data",
    };
  if (!signals.webgl)
    return {
      allowed: false,
      balancedAllowed: false,
      antialias: false,
      reason: "webgl-unsupported",
    };
  return {
    allowed: true,
    ...(signals.viewportWidth === undefined
      ? {}
      : { balancedAllowed: signals.viewportWidth >= 768 }),
    antialias: signals.devicePixelRatio <= 1.25,
  };
}

export function detectLiteCapability(): LiteCapability {
  const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const dataSaver = Boolean(
    (navigator as Navigator & { connection?: { saveData?: boolean } })
      .connection?.saveData,
  );
  const canvas = document.createElement("canvas");
  const webgl =
    canvas.getContext("webgl2", { failIfMajorPerformanceCaveat: true }) ??
    canvas.getContext("webgl", { failIfMajorPerformanceCaveat: true });
  return decideLiteCapability({
    reducedMotion,
    dataSaver,
    webgl: Boolean(webgl),
    devicePixelRatio: window.devicePixelRatio,
    viewportWidth: window.innerWidth,
  });
}
